export default __webpack_public_path__ + "static/media/league-tv.83e24201.png";